import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ImportSuccess.module.scss';
import successImg from '../../../../../assets/images/success.svg';
import ModalFooter from '../../../../../components/ModalFooter';

type Props = {
  onConfirm: () => void;
}

const ImportSuccess: React.FC<Props> = ({ onConfirm }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <img className={styles.img} src={successImg} alt="success" />
      <div className={styles.tip}>{ t('save_success')}</div>
      <ModalFooter
        onConfirm={onConfirm}
        showCancel={false}
      />
    </div>
  );
};

export default ImportSuccess;
